import { ReactNode } from "react";

type PanelHeroVariant = "brand" | "indigo" | "emerald";

const variants: Record<PanelHeroVariant, string> = {
  brand:
    "bg-gradient-to-br from-[#2e436a] via-[#3d5280] to-[#1e2d4a]",
  indigo:
    "bg-gradient-to-br from-indigo-600 via-violet-600 to-[#2e436a]",
  emerald:
    "bg-gradient-to-br from-emerald-600 via-teal-600 to-[#2e436a]",
};

interface PanelHeroProps {
  eyebrow?: string;
  title: string;
  description?: string;
  variant?: PanelHeroVariant;
  action?: ReactNode;
}

export default function PanelHero({
  eyebrow,
  title,
  description,
  variant = "brand",
  action,
}: PanelHeroProps) {
  return (
    <div
      className={`relative overflow-hidden rounded-3xl p-6 text-white shadow-xl md:p-8 ${variants[variant]}`}
    >
      <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-[#cd212a]/25 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-12 left-1/4 h-40 w-40 rounded-full bg-white/10 blur-3xl" />
      <div className="relative flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div className="text-left">
          {eyebrow && (
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/50">{eyebrow}</p>
          )}
          <h1 className="mt-1 text-2xl font-extrabold tracking-tight md:text-3xl">{title}</h1>
          {description && (
            <p className="mt-2 max-w-2xl text-sm text-white/75">{description}</p>
          )}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
    </div>
  );
}
